import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * 3-Phase Power Meter Icon Style 01 - Three Phase Display
 * Uses electric_meter icon with blue color (always "on" when online)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:electric_meter
 */
export const Style01_ThreePhase: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-blue-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      electric_meter
    </span>
  );
};

export default Style01_ThreePhase;
